module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.d1e8f8a8.svg";